var map = {
	"./adult/nn/readingtest-text.js": 820,
	"./adult/no/readingtest-text.js": 821,
	"./adult/se/readingtest-text.js": 822,
	"./youth/de/readingtest-text.js": 823,
	"./youth/nn/readingtest-text.js": 824,
	"./youth/no/readingtest-text.js": 825,
	"./youth/se/readingtest-text.js": 826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;